module.exports = __webpack_public_path__ + "img/banner-9.730ebf34.jpg";